import { MissingAudiosReportItem } from '@mi-front/core';
import { BtnLink, PaginatedTable } from '@mi-front/ui';
import { OpenInNew as OpenInNewIcon } from '@mui/icons-material';
import { useIntl } from 'react-intl';
import { LDate } from '../../../../../../components/date/LDate';
import { LTime } from '../../../../../../components/date/LTime';
import { TimezoneCtxProvider } from '../../../../../../core/context/timezone';
import { ReportResultProps } from '../../../../../../core/reports/types';
import { GlobalMissingAudiosReport } from '../types';

import { FormattedMessage } from 'react-intl';
export function GlobalMissingAudiosReportResult(p: ReportResultProps<GlobalMissingAudiosReport>) {
  const { $t } = useIntl();

  const showStation = p.values.groupBy.id !== 'none';

  const viewScheduleUrlFn = (item: MissingAudiosReportItem) =>
    `/audit/s/${item.station.slug}/schedule/spot/${item.id}`;

  return (
    <TimezoneCtxProvider
      value={{
        timezone: p.values.timezone,
      }}
    >
      <PaginatedTable
        columns={[
          {
            Header: $t({
              id: 'common.station',
              defaultMessage: 'Emisora',
            }),
            accessor: (schedule) => schedule.station.name,
            w: 16,
            width: showStation ? undefined : 0,
          },
          {
            Header: $t({
              id: 'audit.props.customId',
              defaultMessage: 'Custom ID',
            }),
            accessor: (schedule) => schedule.customId,
            w: 16,
          },
          {
            Header: $t({
              id: 'audit.missingAudios.scheduleDatetime',
              defaultMessage: 'Fecha y hora programada',
            }),
            accessor: (schedule) => (
              <div style={{ display: 'flex', gap: '0.5rem' }}>
                <LDate value={schedule.datetime} day="2-digit" month="2-digit" year="2-digit" />
                <LTime value={schedule.datetime} />
              </div>
            ),
            w: 25,
          },
          {
            Header: $t({
              id: 'audit.props.advertiser',
              defaultMessage: 'Anunciante',
            }),
            accessor: (schedule) => schedule.advertiser,
            w: 20,
          },
          {
            Header: $t({
              id: 'audit.props.version',
              defaultMessage: 'Versión',
            }),
            accessor: (schedule) => schedule.version,
            w: 20,
          },
          {
            Header: $t({
              id: 'common.text.actions',
              defaultMessage: 'Acciones',
            }),
            align: 'center',
            accessor: (schedule) => (
              <BtnLink
                size="xs"
                to={viewScheduleUrlFn(schedule)}
                openInNewTab
                icon={<OpenInNewIcon />}
                className="mr-2"
              >
                <FormattedMessage
                  id="audit.missingAudios.viewScheduleBtn"
                  defaultMessage="Ver detalle de entrada"
                />
              </BtnLink>
            ),
          },
        ]}
        data={p.result.items}
      />
    </TimezoneCtxProvider>
  );
}
